var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"achievements"},[_vm._v("\n    绩效管理\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }